import jsPDF from 'jspdf';
import domtoimage from 'dom-to-image';
import { message } from '@grininc/grin-ui';

const usePdf = () => {
    const prepareDOM = () => {
        const removeElements = document.querySelectorAll('.pdf-remove');
        for (let i = 0; i < removeElements.length; i++) {
            removeElements[i].remove();
        }

        const hideElements = document.querySelectorAll('.pdf-ignore, .icon');
        for (let i = 0; i < hideElements.length; i++) {
            hideElements[i].style.display = 'none';
        }

        return {
            removed: removeElements.length,
            hid: hideElements.length
        };
    };

    const savePdf = (image) => {
        // Calculate height of pdf based on height of image.
        // This number configuration was made by trial and
        // error with different length pages.
        const height = Math.min(Math.max(450, Math.round(image.height / 3.2)), 5000);

        // eslint-disable-next-line @babel/new-cap
        const doc = new jsPDF({
            orientation: 'portrait',
            format: [230, height]
        });

        doc.addImage(image, 'JPEG', 20, 20);
        doc.save('activationOverview.pdf');
    };

    const download = async (container) => {
        prepareDOM();

        await domtoimage
            .toPng(container)
            .then((dataUrl) => {
                return new Promise((resolve, reject) => {
                    const image = new Image();
                    image.src = dataUrl;
                    image.onload = () => {
                        savePdf(image);
                        resolve();
                    };
                });
            })
            .catch((_) => {
                message.error('Oops, PDF submit error, refresh & try again!');
            });
    };

    return {
        prepareDOM,
        download
    };
};

export default usePdf;
